import './App.css';
import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './components/ScrollToTop';
import useReveal from './hooks/useReveal';
import Header from './components/Header';
import Hero from './components/Hero';
import Destinations from './components/Destinations';
import TravelStyles from './components/TravelStyles';
import Featured from './components/Featured';
import Packages from './components/Packages';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import VisaStrip from './components/VisaStrip';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import PackageDetail from './pages/PackageDetail';
import DestinationDetail from './pages/DestinationDetail';
import Estimator from './pages/Estimator';
import AdminEnquiries from './pages/AdminEnquiries';
import Terms from './pages/Terms';
import VisaList from './pages/VisaList';
import VisaDetail from './pages/VisaDetail';
import { EnquiryProvider } from './context/EnquiryContext';

function Home() {
  useReveal();
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Destinations />
        <TravelStyles />
        <Featured />
        <Packages />
        <Services />
        <VisaStrip />
        <WhyUs />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <EnquiryProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/packages/:slug" element={<PackageDetail />} />
          <Route path="/destinations/:slug" element={<DestinationDetail />} />
          <Route path="/estimator" element={<Estimator />} />
          <Route path="/visas" element={<VisaList />} />
          <Route path="/visas/:slug" element={<VisaDetail />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/admin/enquiries" element={<AdminEnquiries />} />
        </Routes>
      </EnquiryProvider>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
